export const fromValue = (staticValue) => () => Promise.resolve(staticValue);
